<template>
    <div>
        <div class="loader" v-if="form.busy">
            <img src="/img/spinner.svg" alt="Loading">
        </div>
        <form @submit.prevent="submit">
            <textarea-field placeholder="Enter title" :maxlen="140"  :errors="form.errors.get('title')" v-model="form.title" :form="form" :rows="2" name="title">Blog title (up to 140
                characters)
            </textarea-field>

            <textarea-field :maxlen="2500" placeholder="Enter your story" :errors="form.errors.get('text')" v-model="form.text" :form="form" :rows="12" class="mt-4" name="text">Your story
            </textarea-field>

            <image-field :key="componentkey" ref="imageField" :errors="form.errors.get('file')" v-model="form.file" class="mt-5 mb-5" cover subtitle="PNG, JPG (up to 2MB)">Upload your
                photo
            </image-field>

            <image-field :key="componentkey2" ref="imageField" :errors="form.errors.get('photo')" v-model="form.photo" class="mt-5 mb-5" subtitle="Square format, up to 500kb">Upload your
                photo
            </image-field>
            <div class="row mt-4">
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <input-field name="first_name" placeholder="Marko" :errors="form.errors.get('first_name')" v-model="form.first_name">First name</input-field>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12">
                    <input-field  name="last_name" placeholder="Markovic" :errors="form.errors.get('last_name')" v-model="form.last_name">Last name</input-field>
                </div>
            </div>
            <input-field name="email" type="email" placeholder="marko.markovic@gmail.com" :errors="form.errors.get('email')" v-model="form.email" class="mt-4">Email</input-field>
            <textarea-field :maxlen="500" placeholder="Enter your bio" :errors="form.errors.get('biography')" v-model="form.biography" :form="form" :rows="4" class="mt-4" name="biography">Short bio
            </textarea-field>
            <p class="mt-3">Please do not submit your information more than once. Thank you!</p>
            <div class="w-100 d-flex-center mt-3">
                <button :disabled="form.busy">Send</button>
            </div>
        </form>
    </div>
</template>

<script>
import InputField from "./client-form/InputField";
import TextareaField from "./client-form/TextareaField";
import ImageField from "./client-form/ImageField";
import Form from 'vform'
import objectToFormData from '@admin/objectToForm';

export default {
    name: "NewsForm",
    components: {ImageField, TextareaField, InputField},
    data: function () {
        return {
            form: new Form({
                first_name: '',
                title: '',
                last_name: '',
                email: '',
                biography: '',
                text: '',
            }),
            componentkey: 0,
            componentkey2: 1,
        }
    },
    methods: {
        submit() {
            this.form.submit('post', (route('news.guest.store')), {
                transformRequest: [function (data, headers) {
                    return objectToFormData(data)
                }]
            }).then(res => {
                this.form.reset();
                document.querySelector('button.btn-close').click();
                this.$toast.success("Your message has been sent!", {
                    position: "top-right",
                    timeout: 5000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: true,
                    rtl: false
                });
                this.componentkey++;
                this.componentkey2++;
                Bus.$emit("reset-preview");
            }).catch(() => {
                const container = document.querySelector('.news-body');
                const items = container.getElementsByClassName('invalid');
                const visible = [...items].filter((el) => {
                    // jQuery-like :visible selector
                    return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length );
                });

                if (visible.length > 0) {
                    container.scrollTo({
                        top: items[0].offsetTop - 100,
                        behavior: 'smooth'
                    });
                }
            })
        }
    },
    mounted() {
        document.querySelector('button.close-news').onclick = () => {
            this.form.reset();
            Bus.$emit("reset-preview");
        };
    }
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";
.loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.94);
    display: grid;
    place-items: center;
    z-index: 1000;
}
button:disabled {
    opacity: 0.6!important;
    cursor: not-allowed!important;
}


p {
    width: 100%;
    text-align: center;
    @include font($mulish-light, 18px, 30px, $hajde-black);
    opacity: 50%;
}

button {
    text-align: center;
    border: none;
    background-color: $hajde-sky;
    border-radius: 10px;
    padding: 1rem 1.6rem;
    text-transform: uppercase;
    margin-bottom: 1rem;
    @include font($mulish-bold, 18px, 18px, white);
}
</style>
